import React from "react";

const Pin = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0.5C4.07 0.5 2.5 2.07 2.5 4C2.5 6.75 6 11.5 6 11.5C6 11.5 9.5 6.75 9.5 4C9.5 2.07 7.93 0.5 6 0.5ZM6 5.25C5.31 5.25 4.75 4.69 4.75 4C4.75 3.31 5.31 2.75 6 2.75C6.69 2.75 7.25 3.31 7.25 4C7.25 4.69 6.69 5.25 6 5.25Z"
      />
    </svg>
  );
};

export default Pin;
